<template>
  <div
    class="mt-auto flex w-full flex-wrap items-center justify-between gap-md"
  >
    <div class="flex items-center gap-md">
      <slot name="start" />
    </div>
    <div class="flex items-center gap-sm">
      <slot name="end" />
    </div>
  </div>
</template>
